import {SET_COST_CENTER, SET_COST_CENTERS } from "../../constants/costCenterConstants"
import { SET_BRANCH } from "../../constants/branchConstants";

const initialState = {
  costCenter: null,
  costCenters: [],
  filteredCostCenters: []
}

const costCenterReducer = (state= initialState, action) => {
  switch(action.type){
    case SET_BRANCH:
      return {
        ...state,
        costCenter: action.costCenter
      }
    case SET_COST_CENTERS:
        return {
          ...state,
          costCenters: action.filtered ? state.costCenters : action.costCenters,
          filteredCostCenters: action.filtered ? action.costCenters : state.filteredCostCenters
        }
    default:
        return state;
  }
}

export default costCenterReducer;